/*Package importing*/
import React, { Component } from 'react';
import $ from 'jquery';

/*Components*/
import Input from '../../components/formComponents/input';


/*Assets*/

/*Services*/
import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';


class SignupTab3 extends Component {
  constructor(props){
    super(props);
    this.state = {
      error: "",
      waitResend: 60,
    }
  }

  componentDidMount(){
    this.runTimer();
  }

  buttonClick(e){
    var url = devconfig.vendor+'auth/verify-otp';
    var data = JSON.stringify({
      "type" : 1,
      "otp" : this.state.otp,
      "mobile": this.props.phone
    })
    APIPost(url,data).then(function(response){
      if(response.status == "ok"){
        this.props.success();
      }
      else{
        this.setState({error: response.message});
      }
    }.bind(this))
  }

  runTimer(){
    let timer = this.state.waitResend;
    if(timer>0){
      timer = timer-1;
      this.setState({waitResend: timer});
      setTimeout(() => {
        this.runTimer();
      }, 1000);
    }
  }

  async handleResend(){
    if(!this.state.waitResend&& !this.state.resendLoading){
      this.setState({resendLoading: true});
      var url = devconfig.vendor+'auth/resend-otp';
      var data = JSON.stringify({
        "mobile": this.props.phone
      })
      APIPost(url,data).then(function(response){
        if(response.status == "ok"){
          this.setState({waitResend: 60},()=>this.runTimer())
        }
        else{
          this.setState({error: response.message});
        }
      }.bind(this)); 
    }
  }

  render() {
    if(this.state.apiLoading){
      return(
        null
      )
    }
    return (
      <div className="col-lg-6 col-10 mx-auto e-outer-wrap p-5">
        <div className="row">
          <div  className="col-lg-12">
            <h5>Enter the OTP sent to your mobile number</h5>
          </div>
        </div>
        <div className="row pt-5">
          <div className="col-12">
            <label>One time password (OTP)</label>
            <Input id="e-otp" value={this.state.otp} type="text" className="e-profile-edit" valueChange={(e) => {this.setState({otp: e}) }}/>
          </div>
        </div>

        {
          this.state.error.length ?
            <div className="row">
              <div className="col-12">
                <div className="e-error">{this.state.error}</div>
              </div>
            </div>
          :
            null
        }
        
        
        <div className="row">
          <div className="col-lg-12 mt-3">
           <div className="d-flex w-100 align-items-center justify-content-end">
            <span className={this.state.waitResend || this.state.resendLoading?"pr-3 e-resend-otp-btn": "pr-3 e-resend-otp-btn e-resend-active"} onClick={this.handleResend.bind(this)}>Resend OTP{this.state.waitResend? ` (${this.state.waitResend}s)`: ""}</span>
            {
                this.state.otp ?
                  <span className="e-signup-btn" onClick={this.buttonClick.bind(this)}>Verify</span>
                :
                  <span className="e-signup-btn e-in-active">Verify</span>
              }
           </div>
          </div>
        </div>

      </div>
    );
  }
}

export default SignupTab3;
